import React from "react";
import PropTypes from 'prop-types';

import style from "./Tech.css";

const TechLogos = ({ logos }) => {
  return (
    <div className={style.content}>
      <div className={style.techLogos}>
        {logos.map((logo, idx) => {
          let className = style.techLogo;

          if (idx % 5 === 0) {
            className = style.techLogoFirst;
          }

          return (
            <div
              key={idx}
              className={className}>
              <img
                title={logo.title}
                alt={logo.title}
                className={style.techLogoImg}
                src={logo.image} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

TechLogos.propTypes = {
  logos: PropTypes.array.isRequired
};

export default TechLogos;



// WEBPACK FOOTER //
// ./component/Tech/TechLogos.js